export default __webpack_public_path__ + "src/images/packages/witklipfontein-eco-lodge/93da5341e52559f409e52a0d820fc094-5.jpg";